import {Route, Routes} from 'react-router-dom'
import {PageTitle, PageLink} from '../../../../_metronic/layout/core'
import DocsList from './DocsList'
import DocEdit from './DocEdit'
import CategoriesList from './CategoriesList'
import DocDetails from './DocDetails'

const docsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Docs Management',
    path: '/docs',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DocsPage = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <>
            <PageTitle breadcrumbs={docsBreadcrumbs}>Documentation</PageTitle>
            <DocsList />
          </>
        }
      />
      <Route
        path='new'
        element={
          <>
            <PageTitle breadcrumbs={docsBreadcrumbs}>New Doc</PageTitle>
            <DocEdit />
          </>
        }
      />
      <Route
        path=':id'
        element={
          <>
            <PageTitle breadcrumbs={docsBreadcrumbs}>Doc Details</PageTitle>
            <DocDetails />
          </>
        }
      />
      <Route
        path=':id/edit'
        element={
          <>
            <PageTitle breadcrumbs={docsBreadcrumbs}>Edit Doc</PageTitle>
            <DocEdit />
          </>
        }
      />
      <Route
        path='categories'
        element={
          <>
            <PageTitle breadcrumbs={docsBreadcrumbs}>Manage Categories</PageTitle>
            <CategoriesList />
          </>
        }
      />
    </Routes>
  )
}

export default DocsPage
